module.exports = __webpack_public_path__ + "media/images/gift/gift-ex2-c0b2e4f13e613dda6826f0c0acace6f3.png";